export default
[
    /*{title: "CarBalances.Label.key", dataIndex: "key", key: "key", responsive: ['md']},
    {title: "CarBalances.Label.companyId", dataIndex: "companyId", key: "companyId", responsive: ['md']},*/
    {title: "CarBalances.Label.companyName", dataIndex: "companyName", key: "companyName", responsive: ['md']},


    /*{title: "CarBalances.Label.companyBranchId", dataIndex: "companyBranchId", key: "companyBranchId", responsive: ['md']},*/
    {title: "CarBalances.Label.companyBranchName", dataIndex: "companyBranchName", key: "companyBranchName", responsive: ['md']},
    {title: "CarBalances.Label.carIdNumber", dataIndex: "carIdNumber", key: "carIdNumber", responsive: ['md']},
    {title: "CarBalances.Label.carDriverName", dataIndex: "carDriverName", key: "carDriverName", responsive: ['md']},
    {title: "CarBalances.Label.consumptionValue", dataIndex: "consumptionValue",
    render: value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    parser:value => value!.replace(/\$\s?|(,*)/g, ''),
    key: "consumptionValue", responsive: ['md']},
    {title: "CarBalances.Label.carBalnce", dataIndex: "carBalnce",
    
    
    render: value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    parser:value => value!.replace(/\$\s?|(,*)/g, ''),
    key: "carBalnce", responsive: ['md']},
    /*{title: "CarBalances.Label.carId", dataIndex: "carId", key: "carId", responsive: ['md']},*/
    {title: "CarBalances.Label.subscriptionStartDate", dataIndex: "subscriptionStartDate", key: "subscriptionStartDate", responsive: ['md']},
    {title: "CarBalances.Label.subscriptionEndDate", dataIndex: "subscriptionEndDate", key: "subscriptionEndDate", responsive: ['md']}
]

